import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/paid_box.png")